import React, { useEffect } from 'react';
import { Layout } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import { footerText } from 'util/config';
import App from 'routes/index';
import Sidebar from '../Sidebar/index';
import Topbar from '../Topbar/index';

import { history } from '../../redux/store';

const { Content, Footer } = Layout;

const MainApp = () => {
  const match = useRouteMatch();
  const dispatch = useDispatch();

  const { data: merchants } = useSelector(({ data }) => data.merchantAccounts);
  const activeMerchant = useSelector(({ data }) => data.activeMerchant);
  const defaultPWDChanged = useSelector(({ auth }) => auth.authUser.default_pwd_changed);
  const { location: { pathname }, action } = useSelector(({ router }) => router);

  useEffect(() => {
    if (defaultPWDChanged !== undefined && !defaultPWDChanged
      && (pathname !== '/profile'
        && pathname !== '/signin' && action !== 'POP')
    ) {
      history.push('/profile');
    }
    // else if ((pathname !== '/accounts'
    //   && pathname !== '/dashboard' && action !== 'POP') && !(activeMerchant && activeMerchant._id)
    // ) {
    //   if (defaultPWDChanged) history.push('/accounts');
    // }
  }, [dispatch, activeMerchant, action, pathname]);

  return (
    <Layout className="gx-app-layout">
      <Sidebar />
      <Layout>
        <Topbar />
        <Content className="gx-layout-content">
          <App match={match} />
          <Footer>
            <div className="gx-layout-footer-content">
              {footerText}
            </div>
          </Footer>
        </Content>
      </Layout>
    </Layout>
  );
};
export default MainApp;
